module.exports = __webpack_public_path__ + "static/media/internship-cover-Tablet.441d4af3.png";